import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const FieldsWrapper = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${theme.spacing.md};
  row-gap: 8px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};

  span {
    font-size: ${theme.typography.sizes.xs};
  }
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.sm};
`

export const ButtonWrapper = styled.div``
